(async () => {
  const { text } = await import('@theme/lb-ui');
  let frame = 0;
  let observer;
  function setup() {
    const main = document.querySelector('main');
    const picker = main?.querySelector('variant-picker[data-product-handle^="muslin-front-open-button-jabla-"]');
    if (!picker) return;
    const field = picker.querySelector('.lb-design-image-picker');
    if (field && !field.querySelector('.lb-design-hint')) {
      const hint = document.createElement('p');
      hint.className = 'lb-design-hint';
      hint.textContent = text('design_hint');
      field.append(hint);
    }
    const selected = field?.querySelector('input:checked');
    for (const link of main.querySelectorAll('a[href*="wa.me"]')) {
      const url = new URL(link.href);
      url.searchParams.set('text', text('help_product', { title: main.querySelector('h1')?.textContent.trim() || '', design: selected?.value || '' }));
      link.href = url.toString();
    }
    const gallery = main.querySelector('media-gallery');
    const slides = gallery && [...gallery.querySelectorAll('slideshow-component > slideshow-container > slideshow-slide,slideshow-component slideshow-slide')].filter(slide => !slide.closest('dialog'));
    if (gallery && slides?.length) {
      let counter = gallery.querySelector('.lb-gallery-counter');
      if (!counter) { counter = document.createElement('span'); counter.className = 'lb-gallery-counter'; counter.setAttribute('aria-hidden', 'true'); gallery.append(counter); }
      const active = Math.max(0, slides.findIndex(slide => slide.getAttribute('aria-hidden') === 'false'));
      const label = `${active + 1} / ${slides.length}`;
      if (counter.textContent !== label) counter.textContent = label;
    }
  }
  function schedule() { if (!frame) frame = requestAnimationFrame(() => { frame = 0; setup(); }); }
  function init() {
    observer?.disconnect();
    setup();
    const main = document.querySelector('main');
    if (main) { observer = new MutationObserver(mutations => { if (mutations.some(change => change.addedNodes.length || change.removedNodes.length)) schedule(); }); observer.observe(main, { childList: true, subtree: true }); }
  }
  document.addEventListener('slideshow:select', schedule);
  document.addEventListener('shopify:product:select', event => Promise.resolve(event.promise).then(schedule).catch(() => {}));
  document.addEventListener('shopify:section:load', init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true }); else init();
  window.addEventListener('pagehide', () => { observer?.disconnect(); cancelAnimationFrame(frame); frame = 0; });
  window.addEventListener('pageshow', event => { if (event.persisted) init(); });
})();
